import OriginalPost from './Post.svelte';
import OriginalHeader from './Header.svelte';
import Creator from './Creator.svelte';
import Created from './Created.svelte';
import Content from './Content.svelte';
import Images from './Images.svelte';
import Status from './Status.svelte';
import OriginalActions from './Actions.svelte';
import OriginalAction from './Action.svelte';
import Avatar from './Avatar.svelte';
import Icon from './Icon.svelte';
import Label from './Label.svelte';
const Post = OriginalPost;
Post.Header = OriginalHeader;
Post.Header.Avatar = Avatar;
Post.Header.Creator = Creator;
Post.Header.Created = Created;
Post.Content = Content;
Post.Images = Images;
Post.Status = Status;
Post.Actions = OriginalActions;
Post.Actions.Action = OriginalAction;
Post.Actions.Action.Icon = Icon;
Post.Actions.Action.Label = Label;
export default Post;
